export default {
  login: {
    校友: '校友',
    用户登录: '用户登录',
    忘记登录账号: '忘记登录账号',
    忘记密码: '忘记密码?',
    请输入用户名: '请输入用户名',
    请输入密码: '请输入密码',
    我已阅读: '我已阅读并同意遵守',
    用户协议: '《用户协议》'
  },
  navbar: {
    活动: '活动',
    聚会: '聚会',
    退出: '退出'
  },
  events: {
    navside: {
      活动中心: '活动中心',
      进行中活动: '进行中活动',
      结束的活动: '结束的活动'
    },
    list: {
      去申请: '去查看',
      查看: '查看'
    }
  },
  reunion: {
    navside: {
      已结束的聚会: '已结束的聚会',
      返回当前聚会: '返回当前聚会'
    }
  },

  help: {
    navside: {
      帮助中心: '帮助中心',
      找回密码: '找回密码',
      查找账号: '查找账号'
    },
    findpwd: {
      请输入: '请输入',
      邮箱地址: '邮箱地址',
      确认提交: '确认提交'
    },
    findaccout: {
      请输入: '请输入',
      UWC入学年份: 'UWC入学年份',
      UWC毕业年份: 'UWC毕业年份',
      姓名全名: '姓名全名（中国学生请用中文填写）',
      出生日期: '出生日期',
      确认提交: '确认提交'
    },
    resetpwd: {
      新密码: '新密码',
      确认新密码: '确认新密码'
    }
  },
  mine: {
    navside: {
      用户中心: '用户中心',
      我的信息: '我的信息',
      我的活动: '我的活动',
      修改密码: '修改密码'
    },
    profile: {
      用户照片: '用户照片',
      用户资料: '用户资料',
      请输入: '请输入',
      UWC入学年份: 'UWC入学年份',
      UWC毕业年份: 'UWC毕业年份',
      理事会: '理事会',
      名字: '名字 (中国学生请用拼音填写)',
      姓: '姓 (中国学生请用拼音填写)',
      全名: '全名 (中国学生请用中文填写)',
      昵称: '昵称',
      邮箱: '邮箱',
      UWC学校邮箱: 'UWC学校邮箱',
      出生日期: '出生日期',
      性别: '性别',
      国籍: '国籍',
      如果从常熟UWC: `如果从常熟UWC FP转去其他UWC,请注明最终毕业的UWC校名`,
      '大学/学院': '大学/学院',
      '专业/领域': '专业/领域',
      大学毕业年份: '大学毕业年份',
      '就职（如适用）': '就职（如适用）',
      '实习（如适用）': '实习（如适用）',
      工作领域: '工作领域',
      目前所在国家: '目前所在国家',
      目前所在省份: '目前所在省份',
      目前所在城市: '目前所在城市',
      联系电话: '联系电话',
      社交软件: '社交软件',
      '社交账号（可选）': '社交账号（可选）',
      '我愿意回馈 UWC': '我愿意回馈 UWC',
      我愿意成为演讲嘉宾: '我愿意成为演讲嘉宾',
      其他志愿活动: '其他志愿活动',
      保存修改: '保存修改',
      是: '是',
      否: '否'
    },

    changepwd: {
      请输入: '请输入',
      当前密码: '当前密码',
      新密码: '新密码',
      确认新密码: '确认新密码',
      保存修改: '保存修改'
    }
  },
  tip: {
    请输入正确邮箱地址: '请输入正确邮箱地址',
    修改成功: '修改成功',
    邮件已发送: '邮件已发送，请到邮箱查看邮件！',
    邮件不存在: '邮件地址不存在',
    密码重置成功: '密码重置成功',
    密码重置失败: '没找到用户信息',
    登录失败: '登录失败,请检查账号密码是否正确!',
    密码修改成功: '密码修改成功,请重新登录',
    验证码错误: '验证码错误',
    用户不存在: '用户不存在',
    查询成功: '查询成功',
    必填字段未填写: '有一些字段为必填项，不能为空。'
  },
  form: {
    我要报名: '我要报名',
    已报名: '已报名:查看表单'
  },
  page: {
    校友录: '校友录',
    我的资料: '我的资料',
    我的活动: '我的活动',
    用户协议: '用户协议',
    我同意: '我同意',
    我不同意: '我不同意'
  },
  psw: {
    密码验证: '至少8-16个字符，至少1个大写字母，1个小写字母和1个数字，其他可以是任意字符。',
    确认密码: '两次输入密码不一致'
  }
}
